var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeClose(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    stroke: "white",
    fill: "white",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    id: "input-password-eye-open-light",
    x: 375,
    y: 360,
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 11s1.776-5.365 8.5-5.5C17.224 5.367 19 11 19 11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6V3",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 6.5l.818-2.886M17.5 8l1.664-2.496M6.5 6.5l-.818-2.886M3.5 8L1.836 5.504"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2 11s1.776 4.39 8.5 4.5c6.724.11 8.5-4.5 8.5-4.5",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.218 9.28A3.5 3.5 0 109.28 7.218 1.5 1.5 0 117.218 9.28z",
    stroke: "none"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyBzdHJva2U9IndoaXRlIiBmaWxsPSJ3aGl0ZSIgIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIiBpZD0iaW5wdXQtcGFzc3dvcmQtZXllLW9wZW4tbGlnaHQiIHg9IjM3NSIgeT0iMzYwIgogICAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGcgIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICA8ZyBmaWxsPSJub25lIiA+CiAgICAgIDxwYXRoIGQ9Ik0yIDExczEuNzc2LTUuMzY1IDguNS01LjVDMTcuMjI0IDUuMzY3IDE5IDExIDE5IDExIiAvPgogICAgICA8cGF0aCBkPSJNMTAuNSA2VjMiIG9wYWNpdHk9Ii43Ii8+CiAgICAgIDxwYXRoIGQ9Ik0xNC41IDYuNWwuODE4LTIuODg2TTE3LjUgOGwxLjY2NC0yLjQ5Nk02LjUgNi41bC0uODE4LTIuODg2TTMuNSA4TDEuODM2IDUuNTA0Ii8+CiAgICA8L2c+CiAgICA8cGF0aCBkPSJNMiAxMXMxLjc3NiA0LjM5IDguNSA0LjVjNi43MjQuMTEgOC41LTQuNSA4LjUtNC41IiBmaWxsPSJub25lIi8+CiAgICA8cGF0aCBkPSJNNy4yMTggOS4yOEEzLjUgMy41IDAgMTA5LjI4IDcuMjE4IDEuNSAxLjUgMCAxMTcuMjE4IDkuMjh6IiBzdHJva2U9Im5vbmUiLz4KICA8L2c+Cjwvc3ZnPgo=";
export { SvgEyeClose as ReactComponent };